import Table from './table';
import { tabsTypes } from '../../conig';
import Alert from '../Alert';

export default function InformationSources({
  onChange = () => { },
  formValue = {},
  t = (s) => s,
  section = tabsTypes.MONITORING,
  data = [],
  visible = false,
}) {
  return (
    <div className="form-group">
      {visible && (
        <Alert
          message="You can select which of your available information sources should be included in this analysis."
          localKey={`${section}InformationSources`}
        />
      )}
      <Table
        value={formValue[`${section}InformationSources`]}
        t={t}
        section={section}
        onChange={onChange}
        data={data}
      />
    </div>
  );
}
